export const sortNumbers = (firstNumber: number, secondNumber: number) => {
    if (typeof firstNumber !== "undefined" && firstNumber !== null && typeof secondNumber !== "undefined" && secondNumber !== null) {
        return firstNumber - secondNumber;
    } else if (typeof firstNumber !== "undefined" && firstNumber !== null) {
        return -1;
    } else if (typeof secondNumber !== "undefined" && secondNumber !== null) {
        return 1;
    }
    return 0;
};